import { render } from "./DashboardImport.vue?vue&type=template&id=51d70a36&scoped=true"
import script from "./DashboardImport.vue?vue&type=script&lang=js"
export * from "./DashboardImport.vue?vue&type=script&lang=js"

import "./DashboardImport.vue?vue&type=style&index=0&id=51d70a36&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51d70a36"]])

export default __exports__